import React from 'react';
import LazyImage from '../../../components/CustomLibraries/LazyImage';

function ClirnetOtherCard({ redirect, gtmTagVariable = '' }) {
  return (
    <>
      <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0 loginPageFrmCard">
        <div className="w-100 newLogoCard d-flex flex-column p-3 p-md-4 text-start shadow bg-white rounded-3">
          <span className="m-4 d-flex justify-content-start">
            <p className="fs-2 fw-semibold mb-3">Don't know what CLIRNET does?</p>
          </span>
          <span className="p-4 d-flex flex-row justify-content-between">
            <img
              className=""
              src="https://img-cdn.clirnet.com/medwiki/images/clirnet_logo.jpg"
              alt="Clirnet"
            />
            <button
              onClick={redirect}
              className={`"fs-4 fw-medium ms-auto py-2 px-3 btn btn-outline-secondary rounded py-3 px-4 ${gtmTagVariable}_clirnetOtherCard_click_here_to_find_out`}
              aria-label="Click here to find out"
            >
              Click here to find out
            </button>
          </span>
        </div>
      </div>
    </>
  );
}

export default ClirnetOtherCard;
